import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { makeRequest } from "../../../utils/axios.js"; 

export const useShareLogic = (postToShare, setOpenShare) => {
    const [desc, setDesc] = useState("");
    const queryClient = useQueryClient();
    const [postType, setPostType] = useState("Discussion");

    const isReshare = !!postToShare.originalPostId;
    
    const previewData = {
        name: isReshare ? postToShare.originalName : postToShare.name,
        profilePic: isReshare ? postToShare.originalProfilePic : postToShare.profilePic,
        desc: isReshare ? postToShare.originalDesc : postToShare.desc,
        img: isReshare ? postToShare.originalImg : postToShare.img,
        originalId: isReshare ? postToShare.originalPostId : postToShare.id
    };

    const shareMutation = useMutation({
        mutationFn: (newShare) => makeRequest.post("/posts/share", newShare),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["posts"] });
            setOpenShare(false);
        },
        onError: (err) => {
            alert("Error: " + (err.response?.data || "Unknown error"));
        }
    });

    const handleShareFeed = () => {
        shareMutation.mutate({
            desc: desc,
            originalPostId: previewData.originalId || postToShare.id,
            type: postType,
        });
    };

    return {
        desc,
        setDesc,
        handleShareFeed,
        isLoading: shareMutation.isPending,
        previewData
    };
};